// extracted by mini-css-extract-plugin
export default {"input":"MwGB8y2xrmgcwpcI8dIU"};